export const nameRegExp = new RegExp(/^(?!\s)(?!.*\s\s)[^\p{Emoji}!"#$%&()*+,/:;<=>?@[\]^{|}~]*$/u)
export const usernameRegExp = new RegExp(/^[a-zA-Z0-9-_.]*$/)
export const postalCodeRegExp = /^[0-9]{5}$/
